import { useAuth0 } from '@auth0/auth0-react'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * LoginCallback component that handles the Auth0 authentication callback
 * @returns {JSX.Element} The callback component
 */
const LoginCallback: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth0()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        // Navigate to the original URI or dashboard
        navigate('/mock')
      } else {
        navigate('/login')
      }
    }
  }, [isLoading, isAuthenticated, navigate])

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-b-2 border-indigo-600"></div>
        <p className="mt-4 text-gray-600">Processing login...</p>
      </div>
    </div>
  )
}

export default LoginCallback
